export const yandexMetric = (goal) => {
    window.ym(62599942, "reachGoal", goal)
}